import Vue from 'vue'
import Utils from '../../core/Utils.js'
import data_words from '../../data/words'


// STATE
const state = {
	keys: [],
	player: {
		life: 18,
		life_max: 18,
		level: 1,
		letters_destroyed: 0,
		letters: []
	},
	phases: [],
	prompt: '',
	status: false,
	error: {
		active: false,
		text: ''
	},
	first_time: true,
	notifications: []
}



// GETTERS
const getters = {
	game: function(state) { return state },
	keyboard: function(state) { return _.sortBy(state.keys, 'position') },
	active_phase: function(state) { return _.last(state.phases) },
}



// ACTIONS
const actions = {

	init: function({ commit, state, dispatch, getters }) {
		var keys = []

		Utils.init()

		// Player letters
		commit('EDIT_PLAYER', { letters: Utils.generate_player_letters() })

		// Keyboard
		var n = 1
		for (var i = 0; i < 26; i++) {
			var letter = false
			if (state.player.letters[i]) letter = state.player.letters[i]

			keys.push({
				id: _.uniqueId('touch-'),
				position: n,
				letter: letter,
				pressed: false,
				active: true,
				uses: 0
			})
			n++
		}

		commit('EDIT_STATE', { keys: keys, first_time: true })
	},



	start_game: function({ commit, state, dispatch, getters }) {
		dispatch('new_phase', { type: 'tuto' })
		sounds.play('paper')

		setTimeout(function() {
			commit('EDIT_STATE', { first_time: false })
			sounds.play('bell')
		}, 1000)
	},



	end_game: function({ commit, state, dispatch, getters }) {
		commit('EDIT_PLAYER', { letters: [], life: 18, life_max: 18, level: 1, letters_destroyed: 0 })
		commit('EDIT_STATE', { phases: [], status: false, prompt: '' })
	},



	new_phase: function({ commit, state, dispatch, getters }, data) {
		var type = data.type

		var valid = (!getters.active_phase || getters.active_phase.type != 'lose')

		if (valid) {
			var phase = { id: _.uniqueId('phase-'), type: type }

			if (type == 'fight') {
				phase.enemy = Utils.generate_enemy({ level: state.player.level })
				phase.life_losed = 0

				for (var i in getters.keyboard) {
					var highlight = false
					if (_.filter(phase.enemy.letters, function(l) { return l.letter == getters.keyboard[i].letter }).length) highlight = true
					commit('EDIT_TOUCH', { touch: getters.keyboard[i], highlight: highlight })
				}
			}

			else if (type == 'loot') {
				phase.loots = []
				var n = _.random(2, 3)
				for (var i = 0; i < n; i++) {
					var loot = Utils.generate_loot({ level: state.player.level });
					loot.active = i === 0
					phase.loots.push(loot)
				}

				for (var i in getters.keyboard) {
					commit('EDIT_TOUCH', { touch: getters.keyboard[i], active: false, highlight: false })
				}

				// Remise à zéro du clavier
				for (var i in getters.keyboard) {
					if (!getters.keyboard[i].active) commit('EDIT_TOUCH', { touch: getters.keyboard[i], active: true, uses: 0 })
				}
			}
			
			else if (type == 'lose') {

				for (var i in getters.keyboard) {
					commit('EDIT_TOUCH', { touch: getters.keyboard[i], active: false, highlight: false })
				}

			}
			
			commit('ADD_PHASE', { phase: phase })

			if (state.player.level == 1 && state.phases.length >= 9) commit('EDIT_PLAYER', { level: 2 })
			if (state.player.level == 2 && state.phases.length >= 50) commit('EDIT_PLAYER', { level: 3 })
			if (state.player.level == 3 && state.phases.length >= 100) commit('EDIT_PLAYER', { level: 4 })

			commit('EDIT_STATE', { status: 'ready' })
		}
	},



	set_loot_active: function({ commit, state, dispatch, getters }, data) {
		if (getters.active_phase.type == 'loot') {
			for (var i in getters.active_phase.loots) {
				var active = (getters.active_phase.loots[i] == data.loot);
				commit('EDIT_LOOT', { loot: getters.active_phase.loots[i], active: active })
			}
		}
	},
	


	keydown: function({ commit, state, dispatch, getters }, data) {
		if (data.touch && data.touch.active) {
			sounds.play('key')
			commit('EDIT_STATE', { prompt: state.prompt + data.touch.letter });
			commit('EDIT_TOUCH', { touch: data.touch, pressed: true });
		}
	},

	keyup: function({ commit, state, dispatch, getters }, data) {
		if (data.touch && data.touch.active) {
			commit('EDIT_TOUCH', { touch: data.touch, pressed: false, uses: data.touch.uses + 1 })
			
			var n = _.random(0, 100)
			if (n < data.touch.uses) {
				commit('EDIT_TOUCH', { touch: data.touch, active: false, uses: 0 });
				dispatch('notification', { text: "Oups ! Une touche est restée enfoncée. Vous l'avez surement trop utilisé. Elle finira bien par se débloquer." })
			}
		}
	},



	enter_down: function({ commit, state, dispatch, getters }) {
		var word = state.prompt;
		sounds.play('key')

		if (state.status == 'ready') {

			if (getters.active_phase.type == 'fight' || getters.active_phase.type == 'tuto') {
				if (word.length) {

					if (word.length >= 3) {
						if (word.length <= 7) {
							if (_.includes(data_words[word.length], word)) {

								sounds.play('bell')
								if (getters.active_phase.type == 'fight') dispatch('battle', { word: word })
								else if (getters.active_phase.type == 'tuto') dispatch('new_phase', { type: 'fight' })

							} else
								dispatch('set_error', { error: "Ce mot n'existe pas..." })
						} else
							dispatch('set_error', { error: "Le mot doit avoir moins de 8 caractères." })
					} else
						dispatch('set_error', { error: "Le mot doit avoir plus de 2 caractères." })
					
					commit('EDIT_STATE', { status: 'ready' })
					commit('EDIT_STATE', { prompt: '' })
				} else
					dispatch('set_error', { error: "Vous devez taper un mot avant de le valider." })
			}

			if (getters.active_phase.type == 'loot') {
				var loot = _.find(getters.active_phase.loots, { active: true })
				if (loot) {
					dispatch('gain_loot', { loot: loot })
				}
			}

		}
	},


	battle: function({ commit, state, dispatch, getters }, data) {
		var word = data.word
		commit('EDIT_STATE', { status: 'waiting' })

		for (var i in word) {
			for (var j in getters.active_phase.enemy.letters) {
				if (getters.active_phase.enemy.letters[j].letter == word[i]) {
					commit('EDIT_ENEMY_LETTER', { letter: getters.active_phase.enemy.letters[j], active: false })
					commit('EDIT_PLAYER', { letters_destroyed: state.player.letters_destroyed + 1 })
				}
			}
		}

		// Prendre dégâts
		var damage = 0
		for (var j in getters.active_phase.enemy.letters) {
			var letter = getters.active_phase.enemy.letters[j]
			if (letter.active) {
				damage++
			}
		}
		if (damage) {
			dispatch('deal_damage', { damage: damage })
			commit('EDIT_PHASE', { phase: getters.active_phase, life_losed: damage })
		}
		
		// Phase suivante
		setTimeout(function() {
			var type = 'fight'
			var max = _.random(1, 3)
			if (max === 1) max = _.random(1, 2)
			if (max > 2 && state.player.level === 1) max = 2
			var last_phases = _.takeRight(state.phases, max)
			
			var nb_fights = 0
			for (var i in last_phases) {
				if (last_phases[i].type == 'fight') nb_fights++
			}
			if (nb_fights == max) type = 'loot'

			dispatch('new_phase', { type: type })
		}, 1250)
	},


	set_error: function({ commit, getters, state, dispatch }, data) {
		sounds.play('error')
		commit('EDIT_ERROR', { active: true, text: data.error })
		setTimeout(function() {
			commit('EDIT_ERROR', { active: false })
		}, 2000)
	},


	deal_damage: function({ commit, getters, state, dispatch }, data) {
		var new_life = state.player.life - data.damage
		if (new_life <= 0) {
			new_life = 0
			dispatch('lose')
		}
		commit('EDIT_PLAYER', { life: new_life })
	},


	lose: function({ commit, getters, state, dispatch }, data) {
		sounds.play('lose')
		commit('EDIT_STATE', { status: 'lose' })
		dispatch('new_phase', { type: 'lose' })
	},


	gain_loot: function({ commit, getters, state, dispatch }, data) {
		if (getters.active_phase.type == 'loot') {
			if (data.loot.type == 'heal') {
				var new_life = state.player.life + data.loot.value
				if (new_life > state.player.life_max) new_life = state.player.life_max
				commit('EDIT_PLAYER', { life: new_life })
			}
			else if (data.loot.type == 'letter') {
				var touch = _.find(getters.keyboard, function(key) { return key.letter == false })
				if (touch) {
					commit('EDIT_TOUCH', { touch: touch, letter: data.loot.value, pressed: false, active: true })
					Utils.remove_from_all_letters(data.loot.value)
				}
			}
			else if (data.loot.type == 'life-up') {
				commit('EDIT_PLAYER', { life_max: state.player.life_max + data.loot.value })
			}

			dispatch('new_phase', { type: 'fight' })
		}

	},


	space_down: function({ commit, state, dispatch, getters }) {
		if (state.status == 'ready') {
			sounds.play('key')

			if (getters.active_phase.type == 'fight') {
				dispatch('battle', { word: '' })
			}
			else if (getters.active_phase.type == 'loot') {
				commit('EDIT_STATE', { status: 'waiting' })
				dispatch('new_phase', { type: 'fight' })
			}
			else if (getters.active_phase.type == 'tuto') {
				commit('EDIT_STATE', { status: 'waiting' })
				dispatch('new_phase', { type: 'fight' })
			}
		}
	},



	arrow_down: function({ commit, state, dispatch, getters }, data) {
		sounds.play('key')

		if (getters.active_phase.type == 'loot') {
			var index = _.findIndex(getters.active_phase.loots, { active: true });
			if (data.direction == 'right') {
				if (getters.active_phase.loots[index+1]) dispatch('set_loot_active', { loot: getters.active_phase.loots[index+1] })
			}
			if (data.direction == 'left') {
				if (getters.active_phase.loots[index-1]) dispatch('set_loot_active', { loot: getters.active_phase.loots[index-1] })
			}
		}
	},


	back_space: function({ commit, getters, state, dispatch }, data) {
		if (state.prompt) {
			sounds.play('key')
			commit('EDIT_STATE', { prompt: '' })
		}
	},


	shuffle: function({ commit, getters, state, dispatch }, data) {
		sounds.play('key')
		var slots = _.shuffle(getters.keyboard);
		for (var i in slots) {
			commit('EDIT_TOUCH', { touch: slots[i], position: parseInt(i) })
		}
	},


	notification: function({ commit, getters, state, dispatch }, data) {
		var notification = { id: _.uniqueId('notification-'), text: data.text }
		sounds.play('notification')
		commit('ADD_NOTIFICATION', { notification: notification })
		setTimeout(function() {
			commit('REMOVE_NOTIFICATION', { notification: notification })
		}, 10000)
	},


}



// MUTATIONS
const mutations = {

	EDIT_STATE: function(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i]);
		}
	},

	EDIT_PLAYER: function(state, data) {
		for (var i in data) {
			Vue.set(state.player, i, data[i]);
		}
	},

	EDIT_ERROR: function(state, data) {
		for (var i in data) {
			Vue.set(state.error, i, data[i]);
		}
	},
	
	EDIT_TOUCH: function(state, data) {
		for (var i in data) {
			if (i != 'touch') {
				Vue.set(data.touch, i, data[i]);
			}
		}
	},
	
	EDIT_PHASE: function(state, data) {
		for (var i in data) {
			if (i != 'phase') {
				Vue.set(data.phase, i, data[i]);
			}
		}
	},
	
	ADD_PHASE: function(state, data) {
		state.phases.push(data.phase)
	},
	
	EDIT_ENEMY_LETTER: function(state, data) {
		for (var i in data) {
			if (i != 'letter') {
				Vue.set(data.letter, i, data[i]);
			}
		}
	},
	
	EDIT_LOOT: function(state, data) {
		for (var i in data) {
			if (i != 'loot') {
				Vue.set(data.loot, i, data[i]);
			}
		}
	},
	
	ADD_NOTIFICATION: function(state, data) {
		state.notifications.push(data.notification)
	},
	
	REMOVE_NOTIFICATION: function(state, data) {
		var index = _.findIndex(state.notifications, data.notification)
		if (index > -1) {
			state.notifications.splice(index, 1)
		}

	},
}



export default { state, getters, actions, mutations }


// WEBPACK FOOTER //
// ./src/store/modules/game.js